import type { UserRoleType } from './user-role-type';
import { userRoles } from './user-roles';

export function isValidUserRole(role: string): role is UserRoleType {
  return role in userRoles;
}
